import { Component, OnInit, Input, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { DOCUMENT } from '@angular/common';
import { interval } from 'rxjs';
import { takeWhile, skipWhile } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
})
export class DatetimePickerComponent implements OnInit, OnDestroy {
  
  @Input () selectedDate: string;
  @Output() selectedDateChange = new EventEmitter<string>();
  
  @Input() minDate: string;
  
  private isComponentActive = true;
  
  dayNames   = Object.values(this.translateService.instant('generic.days'  ));
  monthNames = Object.values(this.translateService.instant('generic.months'));
  
  constructor(
    public translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    if (!this.minDate) this.minDate = moment().set('hour', 12).toISOString();
    
    interval(300).pipe(
      takeWhile(() => this.isComponentActive),
      skipWhile(() => !document.querySelector('.picker-wrapper'))).
      subscribe(() => this.renderDay());
  }
  
  renderDay() {
    if (!document.querySelector('.picker-wrapper')) return;
    
    try {
      const parent  = this.document.querySelector('.picker-toolbar');
      const columns = this.document.querySelectorAll('.picker-columns .picker-col .picker-opt-selected');
      
      const day   = +columns[0].textContent;
      const month = +columns[1].getAttribute('opt-index')+1;
      const year  = +columns[2].textContent;
      const dayName = moment(`${year} ${month} ${day}`, 'YYYY MM DD').format('dddd');
      
      if (parent.querySelector('#day-name')) return parent.querySelector('#day-name').textContent = dayName;
      
      const element = this.document.createElement('span');
      
      element.id = 'day-name'
      element.textContent = dayName;
      element.style.transform = 'translate3d(0, 0px, 0)';
      element.style.fontSize = '18px';
      element.style.position = 'absolute';
      element.style.left = '15px';
      element.style.top = '11px';
      element.style.opacity = '.5';
      
      parent.insertBefore(element, parent.firstChild);
    } catch (error) { }
  }
  
  ngOnDestroy() {
    this.isComponentActive = false;
  }

}
